// Empty state for issues list — CTA to create new issue
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { FileText, Plus, SearchX } from 'lucide-react'

interface IssuesEmptyStateProps {
  hasFilters: boolean
  onClearFilters: () => void
}

export function IssuesEmptyState({ hasFilters, onClearFilters }: IssuesEmptyStateProps): JSX.Element {
  const navigate = useNavigate()

  if (hasFilters) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <SearchX className="mb-3 h-12 w-12 text-gray-300" />
        <p className="text-sm font-medium text-kaycoo-charcoal">No issues match your filters</p>
        <p className="mb-4 text-xs text-kaycoo-charcoal-2">Try adjusting the filter criteria</p>
        <Button variant="outline" size="sm" onClick={onClearFilters}>Clear all filters</Button>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <FileText className="mb-3 h-12 w-12 text-gray-300" />
      <p className="text-sm font-medium text-kaycoo-charcoal">No issues recorded yet</p>
      <p className="mb-4 text-xs text-kaycoo-charcoal-2">Start by recording your first D365 issue</p>
      <Button
        onClick={() => navigate('/issues/new')}
        className="bg-kaycoo-teal-dark text-white hover:bg-kaycoo-teal-dark-2"
      >
        <Plus className="mr-1.5 h-4 w-4" /> Record Issue
      </Button>
    </div>
  )
}
